import { API_URL } from '../../../../modules/auth/core/_requests';

// Updated upload function with new binary API implementation
export async function uploadOrderImages(
  workflowId: number, 
  orderId: string, 
  lineItemId: string, 
  files: File[]
): Promise<any> {
  try {
    const uploadResults: any[] = [];

    // Upload files one by one
    for (const file of files) {
      const response = await fetch(`${API_URL}/api/shopify-shipping/shared/image-upload/upload`, {
        method: 'POST',
        headers: {
          'Content-Type': file.type,
          'X-Order-Id': orderId,
          'X-Line-Item-Id': lineItemId,
          'X-Workflow-Id': workflowId.toString(),
          'X-Filename': file.name
        },
        body: file
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || `Upload failed: ${response.status} ${response.statusText}`);
      }

      const result = await response.json();
      uploadResults.push(result);
    }

    return {
      success: true,
      uploadedFiles: uploadResults.flatMap(result => result.uploadedFiles || [])
    };

  } catch (error) {
    console.error('Error uploading images:', error);
    throw new Error(`Failed to upload images: ${error instanceof Error ? error.message : 'Unknown error'}`);
  }
}

// Updated delete function with actual API implementation
export async function deleteOrderImage(imageId: number): Promise<void> {
  try {
    const response = await fetch(`${API_URL}/api/shopify-shipping/shared/order-image/${imageId}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
      }
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || `Delete failed: ${response.status} ${response.statusText}`);
    }

    const result = await response.json();
    
    if (!result.success) {
      throw new Error(result.error || 'Delete failed');
    }

    console.log('Image deleted successfully:', imageId);

  } catch (error) {
    console.error('Error deleting image:', error);
    throw new Error(`Failed to delete image: ${error instanceof Error ? error.message : 'Unknown error'}`);
  }
}